import { render, staticRenderFns } from "./DxpNavBar.vue?vue&type=template&id=1e231530&scoped=true"
import script from "./DxpNavBar.vue?vue&type=script&lang=js"
export * from "./DxpNavBar.vue?vue&type=script&lang=js"
import style0 from "./DxpNavBar.vue?vue&type=style&index=0&id=1e231530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e231530",
  null
  
)

export default component.exports